export default __webpack_public_path__ + "static/media/tube-1-en.d1a58a87.svg";